import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { MoonbaseProvider } from './lib/moonbase';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found.');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <MoonbaseProvider>
        <App />
      </MoonbaseProvider>
    </BrowserRouter>
  </StrictMode>,
);
